export default "__VITE_ASSET__BKljqTMG__"